import { DocLayout } from './DocLayout';

export default function DocOrganizatiileMele() {
  return (
    <DocLayout title="Organizațiile mele">
      <h2>Prezentare generală</h2>
      <p>
        Pagina afișează organizațiile la care ești asociat/ă ca reprezentant.
        De aici poți edita profilul organizației, completa datele legale și accesa pagina DPA.
      </p>

      <h2>Informații afișate</h2>
      <p>Pentru fiecare organizație vezi:</p>
      <ul>
        <li><strong>Logo și nume</strong> — identitatea publică.</li>
        <li><strong>Status validare</strong> — badge Validat (verde) sau Nevalidat (galben).</li>
        <li><strong>Descriere</strong> — text afișat pe pagina publică a prietenului.</li>
        <li><strong>Contact</strong> — persoana de contact, telefon și email.</li>
      </ul>

      <h2>Editare profil</h2>
      <p>Click pe <strong>Editează</strong> pentru a modifica:</p>
      <ul>
        <li><strong>Descriere</strong> — text descriptiv al organizației.</li>
        <li><strong>Date legale</strong> — denumire legală, CIF/CUI, sediu social, reprezentant legal (nume și funcție).</li>
        <li><strong>Contact</strong> — persoana de contact, telefon și email.</li>
      </ul>

      <h3>Date legale</h3>
      <p>
        Datele legale sunt necesare pentru semnarea DPA și accesul la datele participanților.
        Nu sunt obligatorii pentru salvarea profilului, dar sunt obligatorii pentru validare.
      </p>
      <p>
        Dacă organizația a semnat DPA, datele legale sunt afișate doar în citire.
        Pentru a le edita, trebuie să confirmi că modificarea va invalida DPA-ul
        și va trebui re-semnat.
      </p>

      <h2>DPA</h2>
      <p>
        Butonul <strong>DPA</strong> deschide pagina Acordului de Prelucrare a Datelor.
        Consultă <a href="/staff/documentatie/dpa">documentația DPA</a> pentru detalii complete.
      </p>
    </DocLayout>
  );
}
